import getField from '@form/formGenerator'

export const sterilizationCompanyCallSaveUrl = `${import.meta.env.VITE_API_URL}/public/sterilization-calls`

export const sterilizationCompanyCallFormObject = {
  companyName: '',
  tvaNumber: '',
  companyResponsibleFullName: '',
  companyResponsibleCellPhone: '',
  companyResponsibleEmail: '',
  addressResponsibleFullName: '',
  addressResponsibleCellPhone: '',
  addressResponsibleEmail: '',
  isUniqueResponsible: '',
  sterilizationAddress: '',
  sterilizationCity: '',
  sterilizationZipCode: '',
  sterilizationDistrict: '',
  companyHomeAddress: '',
  companyHomeCity: '',
  companyHomeZipCode: '',
  isSevezo: '',
  isFirstScanned: '',
  isSecondScanned: '',
  buildings: '',
  mission: '',
  callType: '',
  userCoordinates: '',
  local: window.localStorage.getItem('local')
}

const sterilizationCompanyCallFormFields = (
  step,
  sterilizationCompanyCallFormObject,
  updateFormObject,
  updateFormObjectProp,
  errors,
  saveForm,
  isLoading,
  t,
  data,
  mission
) => {

  let fields = []

  fields['call'] = [{
    type: 'select',
    name: 'callType',
    label: t('form.call_type'),
    value: sterilizationCompanyCallFormObject.callType,
    key: 'sterilizationCompanyCallFormObject-callType',
    options: [
      { value: '', label: t('form.select_origin') },
      { value: 'company', label: t('form.company') },
      { value: 'coOwnership', label: t('form.co_ownership') }
    ],
    cssClass: 'column is-6',
    isRequired: true
  }, {
    type: 'switcher',
    name: 'isUniqueResponsible',
    label: t('form.is_unique_responsible'),
    value: sterilizationCompanyCallFormObject.isUniqueResponsible,
    cssClass: 'column is-12',
    key: 'sterilizationCompanyCallFormObject-isUniqueResponsible',
  }]

  fields['company'] = [
    {
      type: 'text',
      name: 'companyName',
      label: t('form.company_name'),
      value: sterilizationCompanyCallFormObject.companyName,
      key: 'sterilizationCompanyCallFormObject-companyName',
      cssClass: 'column is-6',
      isRequired: true
    },
    {
      type: 'text',
      name: 'tvaNumber',
      label: t('form.tva_number'),
      value: sterilizationCompanyCallFormObject.tvaNumber,
      key: 'sterilizationCompanyCallFormObject-tvaNumber',
      cssClass: 'column is-6',
      isRequired: true
    }, {
      type: 'text',
      name: 'companyHomeAddress',
      label: t('form.company_home_address'),
      value: sterilizationCompanyCallFormObject.companyHomeAddress,
      key: 'sterilizationCompanyCallFormObject-companyHomeAddress',
      cssClass: 'column is-6'
    }, {
      type: 'select',
      name: 'companyHomeCity',
      label: t('form.city'),
      value: sterilizationCompanyCallFormObject.companyHomeCity,
      key: 'sterilizationCompanyCallFormObject-companyHomeCity',
      cssClass: 'column is-3',
      withIcon: false,
      options: data.cities,
      disabled: false,
      error: []
    }, {
      type: 'text',
      name: 'companyHomeZipCode',
      label: t('form.zip_code'),
      value: sterilizationCompanyCallFormObject.companyHomeZipCode,
      key: 'sterilizationCompanyCallFormObject-companyHomeZipCode',
      cssClass: 'column is-3',
    }, {
      type: 'switcher',
      name: 'isSevezo',
      label: t('form.is_sevezo'),
      value: sterilizationCompanyCallFormObject.isSevezo,
      cssClass: 'column is-12',
      key: 'sterilizationCompanyCallFormObject-isSevezo',
    }
  ]

  fields['establishmentResponsible'] = [{
    type: 'text',
    name: 'companyResponsibleFullName',
    label: t('form.company_responsible_full_name'),
    value: sterilizationCompanyCallFormObject.companyResponsibleFullName,
    key: 'sterilizationCompanyCallFormObject-companyResponsibleFullName',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'text',
    name: 'companyResponsibleCellPhone',
    label: t('form.company_responsible_cell_phone'),
    value: sterilizationCompanyCallFormObject.companyResponsibleCellPhone,
    key: 'sterilizationCompanyCallFormObject-companyResponsibleCellPhone',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'email',
    name: 'companyResponsibleEmail',
    label: t('form.company_responsible_email'),
    value: sterilizationCompanyCallFormObject.companyResponsibleEmail,
    key: 'sterilizationCompanyCallFormObject-companyResponsibleEmail',
    cssClass: 'column is-12',
    isRequired: true
  }]

  fields['callResponsible'] = [{
    type: 'text',
    name: 'addressResponsibleFullName',
    label: t('form.mission_responsible_full_name'),
    value: sterilizationCompanyCallFormObject.addressResponsibleFullName,
    key: 'sterilizationCompanyCallFormObject-addressResponsibleFullName',
    cssClass: `column is-12 ${parseInt(sterilizationCompanyCallFormObject.isUniqueResponsible) ? 'is-hidden' : ''}`
  }, {
    type: 'text',
    name: 'addressResponsibleCellPhone',
    label: t('form.mission_responsible_cell_phone'),
    value: sterilizationCompanyCallFormObject.addressResponsibleCellPhone,
    key: 'sterilizationCompanyCallFormObject-addressResponsibleCellPhone',
    cssClass: `column is-12 ${parseInt(sterilizationCompanyCallFormObject.isUniqueResponsible) ? 'is-hidden' : ''}`
  }, {
    type: 'email',
    name: 'addressResponsibleEmail',
    label: t('form.mission_responsible_email'),
    value: sterilizationCompanyCallFormObject.addressResponsibleEmail,
    key: 'sterilizationCompanyCallFormObject-addressResponsibleEmail',
    cssClass: `column is-12 ${parseInt(sterilizationCompanyCallFormObject.isUniqueResponsible) ? 'is-hidden' : ''}`
  }]

  fields['callLocation'] = [{
    type: 'text',
    name: 'sterilizationAddress',
    label: t('form.sterilization_address'),
    value: sterilizationCompanyCallFormObject.sterilizationAddress,
    key: 'sterilizationCompanyCallFormObject-sterilizationAddress',
    cssClass: 'column is-6',
    isRequired: true
  }, {
    type: 'select',
    name: 'sterilizationCity',
    label: t('form.city'),
    value: sterilizationCompanyCallFormObject.sterilizationCity,
    key: 'sterilizationCompanyCallFormObject-sterilizationCity',
    cssClass: `column is-3 ${0 === mission.isMultipleCities ? 'is-hidden' : ''}`,
    withIcon: false,
    options: data.cities,
    disabled: false,
    error: [],
    isRequired: true
  }, {
    type: 'select',
    name: 'sterilizationDistrict',
    label: t('form.district'),
    value: sterilizationCompanyCallFormObject.district,
    key: 'sterilizationCompanyCallFormObject-district',
    cssClass: 'column is-3',
    withIcon: false,
    options: data.districts,
    disabled: false,
    error: [],
    isRequired: true
  }, {
    type: 'text',
    name: 'sterilizationZipCode',
    label: t('form.zip_code'),
    value: sterilizationCompanyCallFormObject.sterilizationZipCode,
    key: 'sterilizationCompanyCallFormObject-sterilizationZipCode',
    cssClass: 'column is-3',
    isRequired: true
  }]

  fields['callChecks'] = [
    {
      type: 'switcher',
      name: 'isTreatmentNotificationActive',
      label: t('form.is_treatment_notification_active'),
      value: sterilizationCompanyCallFormObject.isTreatmentNotificationActive,
      cssClass: 'column is-12',
      key: 'sterilizationCompanyCallFormObject-isTreatmentNotificationActive',
    }, {
      type: 'switcher',
      name: 'isResponsibilityAssumed',
      label: t('form.is_responsibility_assumed'),
      help: t('form.help_is_responsibility_assumed'),
      value: sterilizationCompanyCallFormObject.isResponsibilityAssumed,
      cssClass: 'column is-12',
      key: 'sterilizationCompanyCallFormObject-isResponsibilityAssumed',
      isRequired: true
    }, {
      type: 'switcher',
      name: 'isDataStoreAccepted',
      label: t('form.is_data_store_accepted'),
      help: t('form.help_is_data_store_accepted'),
      value: sterilizationCompanyCallFormObject.isDataStoreAccepted,
      cssClass: 'column is-12',
      key: 'sterilizationCompanyCallFormObject-isDataStoreAccepted',
      isRequired: true
    }, {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.validate_call_and_add_buildings'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'sterilizationCompanyCallFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(sterilizationCompanyCallFormObject.id),
      key: 'sterilizationCompanyCallFormObject-id'
    },
    {
      type: 'hidden',
      name: 'mission',
      value: parseInt(sterilizationCompanyCallFormObject.mission),
      key: 'sterilizationCompanyCallFormObject-missionid'
    },
    {
      type: 'hidden',
      name: 'callType',
      value: 'company',
      key: 'sterilizationCompanyCallFormObject-callType'
    },
    {
      type: 'hidden',
      name: 'userCoordinates',
      value: sterilizationCompanyCallFormObject.userCoordinates,
      key: 'sterilizationCompanyCallFormObject-userCoordinates'
    }
  ]

  return fields[step].map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}

export default sterilizationCompanyCallFormFields